module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1017-ccb715b1ba21da66da3ac755086f15ab.png";